module.exports = __webpack_public_path__ + "img/5.31cef3b5.png";